import { DashboardLayout } from "layouts/dashboard.layout";
import { ReferredFreeAccountsTable } from "./components/referred-free-accs-table.component"

export function ReferredFreeAccountsPage() {
  return (
    <DashboardLayout>
      <ReferredFreeAccountsTable />
    </DashboardLayout>
  );
}
